module.exports = __webpack_public_path__ + "static/media/ashely.5f978b57.jpg";